import { render, staticRenderFns } from "./Img-block-normal.vue?vue&type=template&id=413e52dc&scoped=true&"
import script from "./Img-block-normal.vue?vue&type=script&lang=ts&"
export * from "./Img-block-normal.vue?vue&type=script&lang=ts&"
import style0 from "./Img-block-normal.vue?vue&type=style&index=0&id=413e52dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e52dc",
  null
  
)

export default component.exports